import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Sparkles, Wand2, Compass, User } from 'lucide-react';

const tabs = [
  { to: '/', label: 'Home', icon: Home, tid: 'nav-home' },
  { to: '/create', label: 'Create', icon: Wand2, tid: 'nav-create' },
  { to: '/ai', label: 'AI', icon: Sparkles, tid: 'nav-ai' },
  { to: '/discover', label: 'Discover', icon: Compass, tid: 'nav-discover' },
  { to: '/profile', label: 'Profile', icon: User, tid: 'nav-profile' },
];

export default function BottomNav() {
  const loc = useLocation();
  if (loc.pathname.startsWith('/admin')) return null;
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-50 glass border-t border-white/10 bottom-nav-safe md:hidden"
    >
      <div className="grid grid-cols-5 h-16">
        {tabs.map(t => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === '/'}
            data-testid={t.tid}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] font-medium no-tap-highlight transition-colors ${
                isActive ? 'text-violet-400' : 'text-slate-400 hover:text-slate-200'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <t.icon className={`w-5 h-5 transition-transform ${isActive ? 'scale-110' : ''}`} />
                <span>{t.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
